const featurePages = {
  "ad": {
    "name": "广告管理",
    "eyebrow": "AD MANAGEMENT",
    "eyebrowColor": "#ffbc07",
    "heroLines": [
      "投放、归因、变现数据分析",
      "一个后台全搞定"
    ],
    "heroDescription": "跨平台数据打通、ROI 视角调优，决策更快。",
    "heroArt": "ad-hero@2x.png",
    "features": [
      {
        "title": "跨平台统一管理",
        "body": "覆盖 Meta、Google、TikTok、Snapchat、Kwai、Apple、Petal Ads、AppLovin、Mintegral、Unity、Liftoff 共 11 个主流媒体平台，一个 XMP 后台完成跨渠道广告管理，适合出海 App 和游戏买量团队。",
        "bullets": [
          "统一管理多账户、多媒体广告",
          "集中查看状态、预算和素材",
          "减少后台切换和重复操作"
        ],
        "art": "ad-1@2x.png",
        "reverse": false
      },
      {
        "title": "批量编辑操作",
        "body": "支持跨账户、跨广告组的批量编辑操作，可快速统一调整状态、预算、出价等字段；同时提供 Excel 编辑方式，适合高频、大规模的海外广告投放管理。",
        "bullets": [
          "批量修改状态、预算、出价等核心字段",
          "支持跨账户、跨广告组统一调整",
          "支持通过 Excel 编辑进一步提升批量处理效率"
        ],
        "art": "ad-2@2x.png",
        "reverse": true
      },
      {
        "title": "多维度 ROI 优化",
        "body": "整合 Campaign、Ad Group、国家、子渠道等维度，结合 ROI/ROAS、LTV 等指标辅助广告优化和预算判断。",
        "bullets": [
          "多维查看投放效果和回收表现",
          "买量与变现数据统一分析",
          "支持 ROI 视角下的调价判断"
        ],
        "art": "ad-3@2x.png",
        "reverse": false
      },
      {
        "title": "子渠道可视化调整",
        "body": "基于 ROI、LTV、次留等后链路数据，在页面内完成子渠道开关与价格调整，减少导表上传。",
        "bullets": [
          "快速判断子渠道质量",
          "页面内调整开关和价格",
          "提升 SDK 广告网络优化效率"
        ],
        "art": "ad-4@2x.png",
        "reverse": true
      },
      {
        "title": "实时数据监控",
        "body": "打通广告平台、MMP 和变现数据，形成统一广告报表，帮助团队更快发现海外买量波动和回收变化。",
        "bullets": [
          "整合投放、归因和变现数据",
          "实时监控成本、转化和 ROAS",
          "辅助出海增长团队快速决策"
        ],
        "art": "ad-5@2x.png",
        "reverse": false
      }
    ]
  },
  "batch": {
    "name": "批量搭建",
    "eyebrow": "BATCH BUILDER",
    "eyebrowColor": "#2650ff",
    "heroLines": [
      "从 1 条到 10,000+ 条广告",
      "一键批量搞定"
    ],
    "heroDescription": "叉乘、绑定、模板套用，跨账号一次创建。",
    "heroArt": "batch-hero@2x.png",
    "features": [
      {
        "title": "跨账号批量创建",
        "body": "支持在 10 个广告账户内同时创建广告，单次任务可结合最多 30 个地区设置、30 个定向设置、30 个预算与出价设置及 30 个创意组，通过组合规则轻松生成超过 10,000 条广告。",
        "bullets": [
          "支持 10 个广告账户同时批量搭建",
          "地区、定向、预算和创意组可灵活组合放大规模",
          "更快启动海外买量测试"
        ],
        "art": "batch-1@2x.png",
        "reverse": false
      },
      {
        "title": "自动创建广告",
        "body": "基于预设筛选规则自动创建广告，支持 Meta、Google、TikTok，减少人工重复建编，适合持续化海外买量投放。",
        "bullets": [
          "按规则自动筛选素材和定向包",
          "支持设置创建频次与持续时间",
          "适合多渠道自动化广告创建"
        ],
        "art": "batch-2@2x.png",
        "reverse": true
      },
      {
        "title": "自动分组",
        "body": "按国家、版位、定向、素材进行叉乘组合或绑定组合，自动生成清晰的广告计划结构。",
        "bullets": [
          "叉乘组合扩大测试覆盖面",
          "绑定组合控制素材对应关系",
          "让批量广告结构更清晰"
        ],
        "art": "batch-3@2x.png",
        "reverse": false
      },
      {
        "title": "模板套用",
        "body": "复用已验证的广告模板和投放配置，快速迁移到新账户、新市场或新素材测试。",
        "bullets": [
          "复用历史成功广告结构",
          "降低从零搭建成本",
          "提升测试到扩量效率"
        ],
        "art": "batch-4@2x.png",
        "reverse": true
      },
      {
        "title": "云端资产库",
        "body": "集中管理定向包、标题包、素材标签包等投放资产，批量搭建时即取即用。",
        "bullets": [
          "沉淀可复用投放资产",
          "搭建时快速调用常用配置",
          "提升团队协作和标准化程度"
        ],
        "art": "batch-5@2x.png",
        "reverse": false
      },
      {
        "title": "智能命名",
        "body": "根据投放时间、地区、定向、素材名等字段自动命名，方便广告管理、搜索和复盘。",
        "bullets": [
          "统一 Campaign 和广告命名规则",
          "减少人工命名差异",
          "便于数据追踪和复盘"
        ],
        "art": "batch-6@2x.png",
        "reverse": true
      },
      {
        "title": "灵活配置",
        "body": "支持自定义组合规则、绑定关系、预算与出价策略，适配复杂海外广告投放场景。",
        "bullets": [
          "灵活设置组合与绑定逻辑",
          "适配多国家、多素材测试",
          "贴合团队真实投放流程"
        ],
        "art": "batch-7@2x.png",
        "reverse": false
      }
    ]
  },
  "creative": {
    "name": "素材中心",
    "eyebrow": "CREATIVE CENTER",
    "eyebrowColor": "#839cff",
    "heroLines": [
      "让爆量素材，",
      "可被沉淀和复用"
    ],
    "heroDescription": "好素材，找得到、看得懂、可持续复用。",
    "heroArt": "creative-hero@2x.png",
    "features": [
      {
        "title": "统一素材库",
        "body": "云端统一管理图片、视频、文案等广告素材，沉淀可复用创意资产，提升出海投放团队协作效率。",
        "bullets": [
          "集中存储多类型创意素材",
          "团队共享同一素材中心",
          "支持素材复用和资产沉淀"
        ],
        "art": "creative-1@2x.png",
        "reverse": false
      },
      {
        "title": "智能评分",
        "body": "基于 ROAS、留存、 LTV 等指标评估素材表现，快速识别高转化创意和可放量素材。",
        "bullets": [
          "结合后链路数据做素材评分",
          "快速筛选高潜力创意",
          "辅助创意测试和放量判断"
        ],
        "art": "creative-2@2x.png",
        "reverse": true
      },
      {
        "title": "多维分析",
        "body": "从点击率、转化率、ROI、生命周期等维度分析素材效果，帮助团队判断测试、迭代和放量方向。",
        "bullets": [
          "查看 CTR、 CVR、 ROI 等指标",
          "快速完成素材复盘和创意洞察",
          "识别高点击与高转化素材"
        ],
        "art": "creative-3@2x.png",
        "reverse": false
      },
      {
        "title": "标签管理",
        "body": "支持 XMP 标签和媒体标签管理，按元素、风格、市场和表现沉淀素材标签，精准锁定跑量素材特征。",
        "bullets": [
          "管理 XMP 标签与媒体标签",
          "按主题、风格和元素归类",
          "快速定位可复用优质创意元素"
        ],
        "art": "creative-4@2x.png",
        "reverse": true
      },
      {
        "title": "智能筛选",
        "body": "按尺寸、类型、标签、投放渠道和表现指标筛选素材，快速挖掘出高 ROI 素材。",
        "bullets": [
          "多维检索图片和视频素材",
          "快速定位素材版本",
          "减少重复制作和查找成本"
        ],
        "art": "creative-5@2x.png",
        "reverse": false
      },
      {
        "title": "素材替换",
        "body": "支持 Meta、 TikTok、 Google 等渠道快速替换图片与视频素材，让创意迭代不必重新创建广告。",
        "bullets": [
          "替换 XMP 创建广告的图片和视频",
          "适配主流海外媒体渠道",
          "加快素材测试和投放验证"
        ],
        "art": "creative-6@2x.png",
        "reverse": true
      }
    ]
  }
};

export default featurePages;
